module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "topten"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "page-loading loader-inner ball-pulse"
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')]) : _vm._e(), _vm._v(" "), _vm._l((_vm.topTen), function(feed, index) {
    return _c('div', {
      staticClass: "feeds"
    }, [_c('feed', {
      key: index,
      attrs: {
        "linker": _vm.jumpToArticle(feed),
        "title": feed.title,
        "desciption": feed.content,
        "author": feed.user.id,
        "board": feed.board,
        "attachment": feed.attachment ? feed.attachment : false
      }
    })], 1)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-049a8fda","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Topten.vue
// module id = 233
// module chunks = 1